import { useContext } from "react";
import {
  Button,
  List,
  ListItem,
  Tooltip,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { SidebarContext } from "src/contexts/SidebarContext";
import {
  AdminPanelSettings,
  ChevronRight,
  WorkspacePremiumTwoTone,
  Settings,
} from "@mui/icons-material";
import ChromeReaderModeTwoToneIcon from "@mui/icons-material/ChromeReaderModeTwoTone";
import { AuthContext } from "src/contexts/JWTAuthContext";
import { MenuWrapper, SubMenuWrapper } from "./styles";
import { FormattedMessage } from "react-intl";

function SidebarMenuShort() {
  const { closeSidebar, setFixedExpanded } = useContext(SidebarContext);
  const { role } = useContext(AuthContext);

  return (
    <MenuWrapper sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    }}>
      <SubMenuWrapper>
        <List component="div">
          <ListItem component="div" sx={{ justifyContent: 'center', mb: 2 }}>
            <Tooltip title={<FormattedMessage id="expandMenu" />} arrow>
              <Button
                disableRipple
                onClick={() => setFixedExpanded(true)}
                startIcon={<ChevronRight />}
              />
            </Tooltip>
          </ListItem>

          <ListItem component="div" sx={{ justifyContent: 'center', mb: 2 }}>
            <Tooltip title={<FormattedMessage id="dashboard" />} arrow>
              <Button
                disableRipple
                component={NavLink}
                onClick={closeSidebar}
                to="/dashboard"
                startIcon={<ChromeReaderModeTwoToneIcon />}
              />
            </Tooltip>
          </ListItem>


          <ListItem component="div" sx={{ justifyContent: 'center', mb: 2 }}>
            <Tooltip title={<FormattedMessage id="licenses" />} arrow>
              <Button
                disableRipple
                component={NavLink}
                onClick={closeSidebar}
                to="/licenses"
                startIcon={<WorkspacePremiumTwoTone />}
              />
            </Tooltip>
          </ListItem>

          {role === "root" && (
            <>
              <ListItem component="div" sx={{ justifyContent: 'center', mb: 2 }}>
                <Tooltip title={<FormattedMessage id="users" />} arrow>
                  <Button
                    disableRipple
                    component={NavLink}
                    onClick={closeSidebar}
                    to="/admins/manage"
                    startIcon={<AdminPanelSettings />}
                  />
                </Tooltip>
              </ListItem>

              <ListItem component="div" sx={{ justifyContent: 'center', mb: 2 }}>
                <Tooltip title={<FormattedMessage id="general" />} arrow>
                  <Button
                    disableRipple
                    component={NavLink}
                    onClick={closeSidebar}
                    to="/settings"
                    startIcon={<Settings />}
                  />
                </Tooltip>
              </ListItem>
            </>
          )}
        </List>
      </SubMenuWrapper>
    </MenuWrapper>
  );
}

export default SidebarMenuShort;